import { CHANGE_SETTING } from "../actions/setting";

const initialState = {
    language: "en_US",
    time_zone: "Asia/Tehran",
    currency: "EUR",
    euro_price: 132900,
};
export default function setting(state = initialState, action = {}) {
    switch (action.type) {
        case CHANGE_SETTING:
            const { set } = action;
            return {
                language: set.lang,
                time_zone: set.time_zone,
                currency: set.currency,
                euro_price: set.euro_price
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/settingReducer.js